import React, { useState } from "react";
import { LayoutTypes } from "./LayoutTypes";
import { useStaticQuery, graphql } from "gatsby";
import { ChakraBaseProvider, Container, Box } from '@chakra-ui/react';
import getTheme from '../../@chakra-ui/gatsby-plugin/theme';
import useConstructor from "../../hooks/useConstructor";
import GlobalConstants from "../../constants/GlobalConstants";
import { Footer, Header } from "../../sections/Navigation";
import { FacilityContext, LayoutContext, LocationContext } from '../context/index';

import '../../../app.css'

// Will be used to wrap all the children with ErrorBoundary or other HOC.


const Layout = ({ children }: LayoutTypes.ILayoutContainer) => {
  const [facilityDetails, setFacilityDetails] = useState({});
  const [layoutDetails, setLayoutDetails] = useState({});
  const [locationDetails, setLocationDetails] = useState({});

  const data = useStaticQuery(
    graphql`{
      datoCmsFacilityDetail {
        showSignUpForAutoPay
        isOptingOutAutoPaymentRestricted
        militaryInfo
        cid
        facilityName
        fontFamily
        id
        colors {
          primary {
            hex
          }
          secondary {
            hex
          }
          tertiary {
            hex
          }
        }
        socialMediaDetails {
          url
        }
        storageHours {
          timeType
          openHours
          closingHours
          is24hours
        }
        workingHours {
          timeType
          originalId
          openHours
          closingHours
          closed
        }
        locationDetails {
          id
          iframeUrl
          locationCity
          locationName
          locationState
          originalId
          googleMapsUrl
          mailingAddressMapUrl
        }
      }
      datoCmsLayout {
        header {
          topBar {
            variant
            notice
            mobileVariant
            message
            originalId
            ctaButtonsConfig {
              url
              showButton
              label
              buttonTypes
              buttonSize
              buttonColor
              textColor
            }
          }
        }
      }
      datoCmsFooter {
        privacyPolicyLink
        syrasoftLogoLink
      }
    }`
  )

  const {
    datoCmsFacilityDetail: {
      fontFamily,
      isDarkTheme,
      colors,
      facilityName
    },
    datoCmsLayout: {
      header
    },
    datoCmsFooter: {
      privacyPolicyLink,
      syrasoftLogoLink
    }
  } = data;
  const { primary, secondary, tertiary, highlighted_section, inactive } = colors[0]
  useConstructor(() => {
    GlobalConstants.initialize({
      fontFamily: fontFamily,
      isDarkTheme: isDarkTheme,
      primaryColor: primary.hex,
      secondaryColor: secondary.hex,
      tertiaryColor: tertiary.hex,
      highlighted_section: highlighted_section,
      inactive: "#E2E0D8"
    });
  });

  const SectionContainerWrapper = (
    <Box display="flex" flexDirection="column" minHeight="100vh" justifyContent={'space-between'}>
      <Box>
        <Box position="fixed" top={0} zIndex="sticky" w='100%'>
          <Header datoCmsData={header[0].topBar} />
        </Box>
        <Box mt={{ base: '77px', md: '117px' }}>
          {
            React.cloneElement(children, {
              FacilityContext,
              LocationContext,
              LayoutContext,
              setFacilityDetails,
              setLayoutDetails,
              setLocationDetails
            })
          }
        </Box>
      </Box>
      <Box>
        <Footer facilityName={facilityName} privacyPolicyLink={privacyPolicyLink} syrasoftLogoLink={syrasoftLogoLink} />
      </Box>
    </Box>
  )

  return (
    <ChakraBaseProvider theme={getTheme()} >
      <Container maxWidth={"none"} padding={"0"} overflow={'hidden'}>
        <FacilityContext.Provider value={facilityDetails} >
          <LayoutContext.Provider value={layoutDetails} >
            <LocationContext.Provider value={locationDetails} >
              {SectionContainerWrapper}
            </LocationContext.Provider>
          </LayoutContext.Provider>
        </FacilityContext.Provider>
      </Container>
    </ChakraBaseProvider>
  )
};

export default Layout;